var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-loading"},[_c('div',{staticClass:"modal-bg"}),_c('div',{staticClass:"modal-ft"},[_c('div',{staticClass:"ani-center"},[_c('span',{staticClass:"ball ball-green"}),_c('span',{staticClass:"ball ball-yellow"})]),_c('p',[_vm._v("載入中")])])])
}]

export { render, staticRenderFns }